import { getWalletApproveAllowanceRequest } from "src/api/approveAllowanceRequestRecord";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { initFields } from "./constants/initFields";
import useGetListParams from "./helpers/useGetListParams";

const ApproveAllowanceRequestRecord = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="approveAllowanceRequestRecord"
      initFields={initFields}
      getTableDataApiFunc={getWalletApproveAllowanceRequest}
      getListParams={getListParams}
    >
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default ApproveAllowanceRequestRecord;
